/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable @next/next/no-img-element */
/* This example requires Tailwind CSS v2.0+ */
import { EventDay, MethodOfDelivery } from '@/types/graphql/types'
import { GlobeAltIcon, WifiIcon } from '@heroicons/react/outline'
import classNames from 'classnames'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { METHOD_OF_DELIVERY } from 'db'
import useTranslation from 'next-translate/useTranslation'

require('dayjs/locale/ar')

dayjs.extend(relativeTime)

const bgColors = [
  'bg-cyan-100 text-cyan-800',
  'bg-yellow-100 text-yellow-800',
  'bg-red-100 text-red-800',
  'bg-red-100 text-red-800',
  'bg-blue-100 text-blue-800',
  'bg-indigo-100 text-indigo-800',
  'bg-purple-100 text-purple-800',
  'bg-pink-100 text-pink-800',
]
const TimeTable = ({
  eventDays,
  methodOfDelivery,
}: {
  eventDays: EventDay[]
  methodOfDelivery: MethodOfDelivery
}) => {
  const { lang } = useTranslation()
  const isArabic = lang === 'ar'
  return (
    <div className="flow-root relative">
      <ul role="list" className="-mb-8">
        {eventDays
          ?.slice()
          ?.filter(eventDay => eventDay.deletedAt === null)
          ?.sort((a, b) => (dayjs(a!.date).isAfter(b!.date) ? 1 : -1))
          .map((day, i) => (
            <li key={day!.id}>
              <div className="relative pb-8">
                {i !== eventDays!.length - 1 ? (
                  <span
                    className={classNames(
                      'absolute top-4  h-full w-0.5 bg-gray-200',
                      isArabic ? 'right-4 -mr-px' : 'left-4 -ml-px',
                    )}
                    aria-hidden="true"
                  />
                ) : null}
                <div className="relative flex gap-2">
                  <div>
                    <span className="h-8 w-8 rounded-full bg-cyan-500 text-white flex justify-center items-center font-bold text-lg">
                      {i + 1}
                    </span>
                  </div>
                  <div className="w-full">
                    <div className="min-w-0 flex-1 pt-1.5 flex justify-between  text-lg leading-6 font-medium text-gray-900">
                      <div>
                        <p className="text-base flex gap-2">
                          <span>
                            {`${isArabic ? day!.outlineAr : day!.outlineEn}`}
                          </span>
                          {methodOfDelivery.id ===
                            METHOD_OF_DELIVERY.onsiteAndOnline.id &&
                          day.methodOfDelivery ? (
                            <span
                              className={classNames(
                                'flex gap-1 items-center px-3 py-1 rounded-full text-sm font-medium',
                                bgColors[day?.methodOfDelivery?.id ?? 1]!,
                              )}
                            >
                              {[
                                METHOD_OF_DELIVERY.online.id,
                                METHOD_OF_DELIVERY.onsiteAndOnline.id,
                                METHOD_OF_DELIVERY.onsiteOrOnline.id,
                              ].includes(day?.methodOfDelivery?.id ?? NaN) && (
                                <WifiIcon className="w-4" />
                              )}
                              {[
                                METHOD_OF_DELIVERY.onsite.id,
                                METHOD_OF_DELIVERY.onsiteAndOnline.id,
                                METHOD_OF_DELIVERY.onsiteOrOnline.id,
                              ].includes(day?.methodOfDelivery?.id ?? NaN) && (
                                <GlobeAltIcon className="w-4" />
                              )}

                              {isArabic
                                ? day?.methodOfDelivery?.titleAr
                                : day?.methodOfDelivery?.titleEn}
                            </span>
                          ) : (
                            ''
                          )}
                        </p>
                      </div>
                      <div className="text-right text-sm whitespace-nowrap">
                        <time dateTime={day?.date}>
                          {dayjs(day?.date).format('DD MMM YYYY')}
                        </time>
                      </div>
                    </div>
                    {day?.trainerLessons
                      ?.slice()
                      ?.sort((a, b) =>
                        dayjs(a!.startTime).isAfter(b!.startTime) ? 1 : -1,
                      )
                      ?.map(lesson => (
                        <p
                          className="text-sm text-gray-500 flex items-start justify-between mt-1"
                          key={lesson?.id}
                        >
                          <span>
                            <span className="text-sm font-medium">
                              {isArabic ? lesson?.outlineAr : lesson?.outlineEn}
                            </span>
                            {lesson?.methodOfTeaching && (
                              <span
                                className={classNames(
                                  'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mx-1',
                                  bgColors[
                                    lesson.methodOfTeaching.id % bgColors.length
                                  ],
                                )}
                              >
                                {isArabic
                                  ? lesson.methodOfTeaching?.titleAr
                                  : lesson.methodOfTeaching?.titleEn}
                              </span>
                            )}
                          </span>
                          <span className="text-sm text-gray-500 min-w-fit">
                            {dayjs(lesson?.startTime).format('hh:mm A')}
                          </span>
                        </p>
                      ))}
                  </div>
                </div>
              </div>
            </li>
          ))}
      </ul>
    </div>
  )
}
export default TimeTable
